<template>
  <div class="result-slider">
    <p class="results">
      {{$t('pages.chart.periodResults')}} <span class="range" v-if="total > 0">{{slider[0]}} → {{slider[1]}}</span>
      <span class="total">Total : {{total}} <span v-if="total == ITEMS_PER_PAGE_FOR_MAP_DISPLAY">({{$t('pages.chart.partResults')}})</span></span>
    </p>
    <el-slider
    v-model="slider"
    v-loading="loading"
    v-if="total > 0"
    range
    :max="end"
    :min="begin"
    @change="onChange">
    </el-slider>
  </div>
</template>

<script>
import { Slider } from 'element-ui'
import { ITEMS_PER_PAGE_FOR_MAP_DISPLAY } from '@/store/search/constants'
import { ROUTE_RESULT } from '@/router'

export default {
  name: 'result-slider',
  props: ['total'],
  components: {
    elSlider: Slider
  },
  data () {
    return {
      values: [null, null],
      ITEMS_PER_PAGE_FOR_MAP_DISPLAY: ITEMS_PER_PAGE_FOR_MAP_DISPLAY
    }
  },
  computed: {
    loading: function () {
      return this.$store.state.search.loadingPeriod
    },
    period: function () {
      return this.$store.state.search.resultsPeriod
    },
    begin: function () {
      if (this.period.begin) return new Date(this.period.begin).getFullYear()
      return null
    },
    end: function () {
      if (this.period.end) return new Date(this.period.end).getFullYear()
      return null
    },
    slider: {
      get: function () {
        if (this.values[0] && this.values[1]) return this.values

        if (this.$route.query.begin && this.$route.query.begin) {
          return [parseInt(this.$route.query.begin), parseInt(this.$route.query.end)]
        }

        if (this.period.begin && this.period.begin) {
          return [new Date(this.period.begin).getFullYear(), new Date(this.period.end).getFullYear()]
        }

        return [null, null]
      },
      set: function (newValue) {
        this.$set(this.values, 0, newValue[0])
        this.$set(this.values, 1, newValue[1])
      }
    }
  },
  methods: {
    onChange (range) {
      let query = Object.assign({}, this.$route.query)
      if (!!range[0] && !!range[1] &&
          // actual begin/end url parameters are different from range values
          ((!!query.begin && query.begin !== range[0]) ||
           (!!query.end && query.end !== range[1]) ||
          // or if begin/end url parameters aren't set,
          // range values are different from begin/end period
           (!query.begin && range[0] !== this.begin) ||
           (!query.end && range[1] !== this.end))) {
        query.begin = range[0]
        query.end = range[1]

        this.$router.push({
          name: ROUTE_RESULT,
          query
        })
      }
    }
  }
}
</script>
<style>
.result-slider {
  position: absolute;
  bottom: 0;
  z-index: 2;
  width: 100%;
  background: white;
}

.result-slider .el-slider {
  padding: 0 30px 12px 30px;
}

.results {
  margin: 0;
  padding: 20px 30px 0 30px;
  font-size: 13px;
}

.total {
  float: right;
}

.range {
  font-weight: bold;
  color: #35C1D6;
}
</style>



// WEBPACK FOOTER //
// src/components/Result/ResultSlider.vue